"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgYahoo(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.628 0 12 5.372 12 12s-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0zM6.45 6.548c-.005.005-.005.014-.005.02l3.586 6.266-.065 4.697c0 .005.004.014.004.014.005 0 .005.005.01.005h.01c.191-.09.435-.136.688-.136.249 0 .492.047.68.131.005 0 .005.005.01 0 .009 0 .018-.01.018-.014v-.004l-.066-4.674 3.596-6.281c.004-.005.004-.014-.005-.019-.005-.005-.014-.01-.019-.005a1.665 1.665 0 01-.712.146c-.263 0-.516-.052-.708-.146-.01-.004-.019 0-.024.005l-2.77 4.795-2.77-4.795c-.005-.01-.014-.01-.024-.01a1.658 1.658 0 01-.707.146c-.263 0-.516-.051-.708-.145-.005-.005-.014-.005-.019.004zm8.283 10.111c-.061.422.23.811.651.872a.77.77 0 00.872-.651.774.774 0 00-.651-.872.768.768 0 00-.872.651zm1.383-9.496a8.216 8.216 0 00-.038.407 76.463 76.463 0 01-.647 7.397c-.004.038-.004.066-.01.08 0 .005 0 .01.006.014 0 0 .004.005.009.005h.005c.107-.02.22-.02.337-.005.094.014.178.037.263.07.004.005.009.005.014 0l.01-.01a.498.498 0 00.013-.065 74.278 74.278 0 011.49-7.289c.043-.215.071-.351.076-.384a.781.781 0 00-.656-.872.77.77 0 00-.872.651z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgYahoo;
exports.default = _default;